import { orderBy, findIndex } from 'lodash'

// 表示順のソート基準(Menu.vue の vendiblesByType と同じ)
export const sortVendibles = vendibles => orderBy(vendibles, ['attributes.position', 'attributes.name'], ['asc', 'asc'])

/**
 * ドラッグ並び替えの結果を「絞り込み前の全件」に反映し、position を 0..n-1 で振り直す。
 *
 * タグ絞り込み中に並び替えると表示リストは全件の部分集合になる。
 * 表示リストだけに 0..k を振ると非表示アイテムの position と衝突して全体の順が崩れるため、
 * 全件を基準に「移動したアイテムを表示上の隣接行のすぐ隣に差し込む」形で再採番する。
 *
 * @param {Array} all      同タイプの全 vendible(絞り込み前)
 * @param {Array} visible  現在表示中の vendible(絞り込み後・並び替え前の表示順)
 * @param {number} oldIndex Sortable.js の oldIndex(visible 基準)
 * @param {number} newIndex Sortable.js の newIndex(visible 基準)
 * @returns {{ order: Array, changes: Array<{id: string, position: number}> }}
 *   order: 並び替え後の全件、changes: position が変わる vendible だけの {id, position}
 */
export const reorderPositions = ({
  all, visible, oldIndex, newIndex,
}) => {
  const sortedAll = sortVendibles(all)
  const moved = visible[oldIndex]

  if (!moved || oldIndex === newIndex) return { order: sortedAll, changes: [] }

  const visibleAfter = [...visible]
  visibleAfter.splice(oldIndex, 1)
  visibleAfter.splice(newIndex, 0, moved)

  const rest = sortedAll.filter(v => v.id !== moved.id)

  let insertAt
  if (newIndex > oldIndex) {
    // 下へ移動: 表示上の直前行のすぐ後ろに差し込む
    const prev = visibleAfter[newIndex - 1]
    const prevIdx = findIndex(rest, v => v.id === prev.id)
    insertAt = prevIdx === -1 ? rest.length : prevIdx + 1
  } else {
    // 上へ移動: 表示上の直後行のすぐ前に差し込む
    const next = visibleAfter[newIndex + 1]
    const nextIdx = findIndex(rest, v => v.id === next.id)
    insertAt = nextIdx === -1 ? rest.length : nextIdx
  }

  const order = [...rest]
  order.splice(insertAt, 0, moved)

  const changes = []
  order.forEach((v, idx) => {
    if (v.attributes.position !== idx) changes.push({ id: v.id, position: idx })
  })

  return { order, changes }
}
